import { useField, useFormikContext } from 'formik'

const FormTextarea = ({ name, label, placeholder, rows = 5 }) => {
  const [field, meta] = useField(name)
  const { submitCount } = useFormikContext()
  const showError = Boolean(meta.error && (meta.touched || submitCount > 0))

  return (
    <div className="mb-4 last:mb-0">
      {label ? (
        <label className="mb-2 block text-left text-sm font-medium text-gray-700" htmlFor={field.name}>
          {label}
        </label>
      ) : null}
      <textarea
        {...field}
        id={field.name}
        rows={rows}
        placeholder={placeholder}
        className={`min-h-[120px] w-full resize-y rounded-md border px-3 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#006EAB] focus:border-[#006EAB] ${
          showError ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-gray-100'
        }`}
      />
      {showError ? <span className="mt-1 block text-xs text-red-500">{meta.error}</span> : null}
    </div>
  )
}

export default FormTextarea
